import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { useHistory, useParams } from "react-router-dom";
import "react-accessible-accordion/dist/fancy-example.css";
import {
  calculateRenewalDays,
  handleCatch,
  verifyUserType,
  verifyUserTypeConnectedRegistrar,
} from "../../../shared/helpers";

import StyledPrescriptionAuthorisationForm from "./StyledPAF";

import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";

import CloseIcon from "../../../assets/icons/close.svg";

import { App } from "../../../routes/Constants";
import QuitModal from "../../common/Modal/QuitModal";
import InfoPAF from "../../common/InfoPAF/InfoPAF";
import ViewPAF from "../../common/ViewPAF/ViewPAF";

import { registrationCategory } from "../../../constants/register.constants";
import LocalStorage from "../../../shared/localStorage";
import axios from "axios";
import APIVariables from "../../../services/api-variables";
import { typeOfPAF } from "../../../constants/typeOfPAF";
import { Virtuoso } from "react-virtuoso";

import Loader from "../../common/Loader/Loader";
import Footer from "../../common/Footer/Footer";
import moment from "moment";

const PrescriptionAuthorisationForm = () => {
  const history = useHistory();
  const { userID } = useParams();
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const isPrescriber = verifyUserType(registrationCategory.PRESCRIBER);
  const isPharmacy = verifyUserType(registrationCategory.PHARMACY);
  const isConnectedRegistrar = verifyUserTypeConnectedRegistrar(
    registrationCategory.CONNECTED_REGISTRAR
  );

  const [userInfo, setUserInfo] = useState([]);
  const [items, setItems] = useState([]);

  const [quitModalIsOpen, setIsOpenQuit] = useState(false);

  const lastFormID = items.length && items[items.length - 1].id;

  const [detailsPAF, setDetailsPAF] = useState([]);

  const [activatedItem, setActivateTab] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [canReorder, setCanReorder] = useState(false);

  function typeOfForm() {
    const patientType = userInfo.patient_type || items.patient.patient_type;
    if (patientType === "Male") {
      return typeOfPAF.MALE;
    } else if (patientType === "Woman of Non-Childbearing Potential") {
      return typeOfPAF.WOMANOFNCP;
    }
    return typeOfPAF.WOMANOFCP;
  }

  const isLastFormUnderReview =
    items &&
    items.length &&
    items[items.length - 1].status_name === "Submitted";

  useEffect(() => {
    //when we get access to endpoint /prescriptions/{ID} we have to implement from pharmacy perspective
    getPAF();

    // added window.location.pathname fixed a bug when finding a patient from top menu is not chanching the UI
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const getDataAboutCurrentForm = async (id) => {
    setActivateTab(id);
    const item = detailsPAF.find((element) => element.id === id);

    if (item) {
      return item;
    } else {
      const res = await axios
        .get(process.env.REACT_APP_BASE_URL + APIVariables.PRESCRIPTIONS + id, {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        })
        .catch((error) => {
          handleCatch(error);
        });

      if (res?.status === 200) {
        setDetailsPAF([...detailsPAF, res.data]);
      }
    }
  };

  const detailsSelectedPAF = (pafID) => {
    return detailsPAF.find((element) => element.id === pafID);
  };

  const getPAF = async () => {
    const res = await axios
      .get(
        process.env.REACT_APP_BASE_URL + APIVariables.PATIENTS_DETAILS + userID,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .catch(function (error) {
        handleCatch(error);
        setIsLoading(false);
      });
    if (res?.status === 200) {
      let infoUser = { ...res.data };
      delete infoUser.prescriptions;
      setUserInfo(infoUser);
      setItems(res.data.prescriptions);
      setCanReorder(res.data.can_order);
      setIsLoading(false);
    }
  };

  function closeForm() {
    if (isPharmacy) {
      if (items.status === "Approved" || items.status === "Rejected") {
        history.push(App.VIEW_PATIENTS);
      } else {
        setIsOpenQuit(true);
      }
    } else {
      history.push(App.VIEW_PATIENTS);
    }
  }

  function closeModalQuit() {
    setIsOpenQuit(false);
  }

  function quitModal() {
    history.push(App.VIEW_PATIENTS);
  }

  const extractSumaryPAF = (index, item) => {
    return `PAF ${index + 1} - ${item.molecule} ${
      item.capsule_strength_name
        ? item.capsule_strength_name
        : item.capsule_strength + "mg X " + item.n_cycles + " Cycle"
    }`;
  };

  const redirectToOrderForm = (item) => {
    if (!!item?.order_id) {
      history.push(App.ORDER_EDIT_DEFAULT + item?.id + "/" + item?.order_id);
    } else {
      history.push(App.ORDER_DEFAULT + item?.id);
    }
  };

  if (isLoading) return <Loader />;

  return (
    <StyledPrescriptionAuthorisationForm>
      <div className="layout-modal">
        <div className="close-icon" onClick={closeForm}>
          <img src={CloseIcon} alt="Close Icon" />
        </div>
        <div className="min-height">
          <div className="wrapper-flex custom-style">
            <h1 className="select-category-txt">
              Prescription Authorisation Form
            </h1>

            {isPharmacy && (
              <button
                className="green-button"
                disabled={!canReorder}
                onClick={() => redirectToOrderForm(items[items.length - 1])}
              >
                Order Form <ArrowNextWhite />
              </button>
            )}

            {(isPrescriber || isConnectedRegistrar) && (
              <div className="wrapper-flex">
                {!isLastFormUnderReview && (
                  <div className="renew-button">
                    <button
                      className="second-button"
                      onClick={() => {
                        history.push(
                          lastFormID
                            ? App.PAF_RENEW_DEFAULT +
                                `${typeOfForm()}/${userID}/${lastFormID}`
                            : App.PAF_RENEW_DEFAULT +
                                `${typeOfForm()}/${userID}`
                        );
                      }}
                    >
                      Renew PAF <ArrowNextWhite />
                    </button>
                    <div className="renewal-text">Renewal Available</div>
                    {userInfo.patient_type ===
                      "Woman of Childbearing Potential" &&
                    items[items.length - 1]?.status_name === "Submitted" ? (
                      <div className="extra-text-button font-size-10">
                        {calculateRenewalDays(
                          items[items.length - 1]?.pfa_issued
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          <InfoPAF patientDetails={userInfo} />

          <Accordion allowZeroExpanded>
            <Virtuoso
              // endReached={existMoreItems && fetchMoreData}
              style={{ height: "400px", overflowX: "hidden" }}
              data={items}
              itemContent={(index, item) => (
                <AccordionItem key={index}>
                  <AccordionItemHeading
                    onClick={() => getDataAboutCurrentForm(item.id)}
                  >
                    <AccordionItemButton>
                      <h2>
                        {extractSumaryPAF(index, item)}{" "}
                        <div className="paf-issued-date">
                          <span>PAF Issued:</span>{" "}
                          <span className="paf-issues-date">
                            {moment(item.pfa_issued).format("DD / MM / YY")}
                          </span>
                        </div>
                      </h2>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="wrapper-pannel">
                      {activatedItem === item.id && (
                        <ViewPAF
                          form={detailsSelectedPAF(item.id)}
                          isPrint={false}
                          isPrescriber={isPrescriber}
                          index={index + 1}
                        />
                      )}
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              )}
            />
          </Accordion>
        </div>
      </div>

      <Footer />

      {quitModalIsOpen && (
        <QuitModal
          quitModalIsOpen={quitModalIsOpen}
          closeModalQuit={closeModalQuit}
          quitModal={quitModal}
          description="Are you sure you want to cancel filling out this form? All progress will be lost and you will need to start again."
        />
      )}
    </StyledPrescriptionAuthorisationForm>
  );
};
export default PrescriptionAuthorisationForm;
